import React from "react";
import { CloseIcon } from "../../../assets/icons";
import FileDisplay from "../../../utils/FileDisplay";
import NuDateFormat from "../../../utils/NuDate";
import { ViewLabelwithDataBg } from "../../../components/View/ViewLabelwithData";

function ViewAuditSchedule({ visible, onClose, data }) {
  if (!visible) return null;

  return (
    <div
      id="modal"
      className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm 
  flex justify-center items-center z-10"
    >
      <div className="bg-white p-2 rounded w-10/12 max-h-[calc(100vh-80px)] overflow-hidden">
        <div className="flex items-start justify-between px-5 py-2  rounded-t">
          <h3 className="text-base 2xl:text-xl capitalize font-semibold">
            {data?.name || "Audit View"}
          </h3>
          <span
            className="h-6 w-6 text-2xl block cursor-pointer"
            onClick={onClose}
          >
            <CloseIcon />
          </span>
        </div>
        <div className="overflow-y-auto max-h-[calc(100vh-140px)]">
          <div>
            <ViewLabelwithDataBg title="Audit Start Date" value={
              data?.start_date && NuDateFormat({
                value: data?.start_date,
                format: "DD-MMM-yyyy",
              }) || "-"
            } />
            <ViewLabelwithDataBg title="Audit End Date" value={
              data?.end_date && NuDateFormat({
                value: data?.end_date,
                format: "DD-MMM-yyyy",
              }) || "-"
            } />
            <ViewLabelwithDataBg title="Reference Number" value={data?.reference_number || "-"} />
            <ViewLabelwithDataBg title="Performed By" value={data?.performed_by||"-"} />
            <ViewLabelwithDataBg title="Process Description" value={data?.process_description||"-"} />
            <ViewLabelwithDataBg title="Audit Description" value={data?.audit_description||"-"} />
            <ViewLabelwithDataBg title="Auditee" value={data?.auditee||"-"} />
            <ViewLabelwithDataBg title="Result" value={data?.result||"-"} />
            <ViewLabelwithDataBg title="Status" value={data?.status||"-"} />

            <div className="my-3 text-left">
              <p className="text-sm text-[#1D1818] font-semibold mb-1 pl-8">
              Artefact
              </p>
              <div className=" w-full flex flex-wrap">
                {data?.attachment &&
                  data?.attachment.map((i) => {
                    return (
                      <div className=" m-1">
                        <FileDisplay data={i} view={true} height={"45px"} width={"45px"} />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewAuditSchedule;
